module.exports = __webpack_public_path__ + "img/4.a8a188bc.png";